import * as React from "react";
import { IconBase, IIconBase } from "./IconBase";

export const VisibilityIcon = ({ ...props }: IIconBase) => (
  <IconBase {...props} viewBox="0 0 48 48">
    <title>visibility</title>
    <path d="M44 23.4A20.67 20.67 0 0 0 24.1 9 20.67 20.67 0 0 0 4.19 23.4L4 24l.18.6A20.67 20.67 0 0 0 24.1 39 20.67 20.67 0 0 0 44 24.6l.19-.6ZM24.1 35A16.69 16.69 0 0 1 8.21 24 16.69 16.69 0 0 1 24.1 13 16.68 16.68 0 0 1 40 24a16.68 16.68 0 0 1-15.9 11Zm-9-13a9 9 0 1 0 9-9 9 9 0 0 0-9 9Zm9-5a5 5 0 1 1-5 5 5 5 0 0 1 5-5Z"></path>
  </IconBase>
);
